import { Carousel, consts } from 'react-responsive-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegramPlane } from '@fortawesome/free-brands-svg-icons';
import { GITBOOK_LINK } from '../../constants';
import { TeamMembers } from '../../constants/team'
import './OurTeam.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const OurTeam = () => {

  const Arrow = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? '👈' : '👉'
    return (
      <button onClick={onClick} disabled={isEdge}>
        {pointer} arrrow
      </button>
    )
  }

  return (
    <div>
    <div className='outTeam' id='ourTeam'>
      <label className='ourTeam__title'>Our Team</label>
      <label className='ourTeam__text'>
      There are humans behind DCRC Racing. We have been working night and day to provide you with the best P2E game on the Avalanche Network
      </label>
      <div className='ourTeam__desk__carousel'>
        <Carousel 
          showThumbs={false}
          showArrows={true}
          showStatus={false}
          renderArrow={Arrow}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            const defStyle = { display:'inline-block', marginLeft:20, backgroundColor:'#FF4747', opacity:'40%', cursor:'pointer', width:'240px', height:'10px' };
            const style = isSelected
              ? { ...defStyle, opacity: '100%' }
              : { ...defStyle };
            return (
              <span
                style={style}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                src=''
              />              
            );
          }}
        >
          <div className='ourTeam__carousel__item'>
            {TeamMembers.slice(0, 4).map(member => 
            <div className='ourTeam__carousel__member'>
              <div className='ourTeam__carousel__member__box'>
                <img src={member.image} className='ourTeam__carousel__item__img' alt='team'/>
                <div className='ourTeam__carousel__member__info'>
                  <label><FontAwesomeIcon icon={faTwitter} style={{marginRight:'4px'}}/>{member.twitter}</label>
                  <label><FontAwesomeIcon icon={faTelegramPlane} style={{marginRight:'4px'}}/>{member.telegram}</label>
                </div>
              </div>
              <label style={{width:'200px', margin:'auto'}}>{member.name}</label>
            </div>
            )}
          </div>
          {/* <div className='ourTeam__carousel__item'>
            {TeamMembers.slice(4, 8).map(member => 
            <div className='ourTeam__carousel__member'>
              <div className='ourTeam__carousel__member__box'>
                <img src={member.image} className='ourTeam__carousel__item__img' alt='team'/>
                <div className='ourTeam__carousel__member__info'>
                  <label><FontAwesomeIcon icon={faTwitter} style={{marginRight:'4px'}}/>{member.twitter}</label>
                  <label><FontAwesomeIcon icon={faTelegramPlane} style={{marginRight:'4px'}}/>{member.telegram}</label>
                </div>
              </div>
              <label style={{width:'200px', margin:'auto'}}>{member.name}</label>
            </div>
            )}
          </div>
          <div className='ourTeam__carousel__item'>
            {TeamMembers.slice(8, 10).map(member => 
            <div className='ourTeam__carousel__member'>
              <div className='ourTeam__carousel__member__box'>
                <img src={member.image} className='ourTeam__carousel__item__img' alt='team'/>
                <div className='ourTeam__carousel__member__info'>
                  <label><FontAwesomeIcon icon={faTwitter} style={{marginRight:'4px'}}/>{member.twitter}</label>
                  <label><FontAwesomeIcon icon={faTelegramPlane} style={{marginRight:'4px'}}/>{member.telegram}</label>
                </div>
              </div>
              <label style={{width:'200px', margin:'auto'}}>{member.name}</label>
            </div>
            )}
          </div> */}
        </Carousel>
      </div>

      <div className='ourTeam__mobile'>
        { TeamMembers.map(member => 
        <div className='ourTeam__carousel__member'>
          <div className='ourTeam__carousel__member__box'>
            <img src={member.image} className='ourTeam__carousel__item__img' alt='team'/>
            <div className='ourTeam__carousel__member__info'>
              <label><FontAwesomeIcon icon={faTwitter} style={{marginRight:'4px'}}/>{member.twitter}</label>
              <label><FontAwesomeIcon icon={faTelegramPlane} style={{marginRight:'4px'}}/>{member.telegram}</label>
            </div>
          </div>
          <label style={{width:'200px', margin:'auto'}}>{member.name}</label>
        </div>
        )}
      </div>     
    </div>
      <div>
        Discover more about the team members on <a href="" target='_blank' style={{color:'white'}}>GitHub(Coming Soon)</a>
      </div>
    </div>
  )
}

export default OurTeam;